module.exports = __webpack_public_path__ + "static/img/19079B_2_R_20210814_fit.0396a60.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/19079B_2_R_20210814_fit.png
// module id = Q+in
// module chunks = 0